import {
  Dashboard as DashboardIcon,
  Group as GroupIcon,
  Person as PersonIcon,
  EventNote as EventNoteIcon,
  AccountBalanceWallet as AccountBalanceWalletIcon,
  ManageAccounts as ManageAccountsIcon,
  SupervisorAccount as SupervisorAccountIcon,
  BarChart as BarChartIcon,
  VpnKey as VpnKeyIcon,
  ExitToApp as ExitToAppIcon,
} from "@mui/icons-material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import BuildIcon from "@mui/icons-material/Build";
import {
  VENDOR_BOOKINGS,
  VENDOR_CHANGE_PASSWORD,
  VENDOR_CUSTOMERS,
  VENDOR_DASHBOARD,
  VENDOR_INVOICES,
  VENDOR_PROFILE_UPDATE,
  VENDOR_REPORTS,
} from "../Routes/VendorRoutes";

export const vendorMenuItems = [
  {
    text: "Dashboard",
    icon: <DashboardIcon sx={{ color: "#3F51B5" }} />,
    path: VENDOR_DASHBOARD,
  },
  {
    text: "Customers",
    icon: <PersonIcon sx={{ color: "#2196F3" }} />,
    path: VENDOR_CUSTOMERS,
  },
  {
    text: "Bookings",
    icon: <EventNoteIcon sx={{ color: "#FF9800" }} />,
    path: VENDOR_BOOKINGS,
  },

  {
    text: "Invoices",
    icon: <AccountBalanceWalletIcon sx={{ color: "#D32F2F" }} />,
    path: VENDOR_INVOICES,
  },
  // {
  //   text: "Reports",
  //   icon: <BarChartIcon sx={{ color: "#F57C00" }} />,
  //   path: VENDOR_REPORTS
  // },
  {
    text: "Profile",
    icon: <AccountCircleIcon sx={{ color: "#4CAF50" }} />,
    path: VENDOR_PROFILE_UPDATE,
  },
  {
    text: "Change Password",
    icon: <VpnKeyIcon sx={{ color: "#009688" }} />,
    path: VENDOR_CHANGE_PASSWORD,
  },

  {
    text: "Logout",
    icon: <ExitToAppIcon sx={{ color: "#CC0033" }} />,
    action: "logout",
  },
];
